<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Create City</h3>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            City
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./CityCreateSteps/FirstStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getfirstStepData() {
      var data = {
        name: this.$refs["step1"].name,
        country: this.$refs["step1"].country,
        population: this.$refs["step1"].population,
        area_code: this.$refs["step1"].area_code,
        cost_of_living: this.$refs["step1"].cost_of_living,
        number_of_state_uni: this.$refs["step1"].number_of_state_uni,
        number_of_private_uni: this.$refs["step1"].number_of_private_uni,
        general_info: this.$refs["step1"].general_info,
        training: this.$refs["step1"].training,
        climate: this.$refs["step1"].climate,
        lat: this.$refs["step1"].lat,
        long: this.$refs["step1"].long
      };
      var post_data = {};
      for (const field in data) {
        if (data[field]) {
          if (data[field] instanceof Date) {
            post_data[field] = data[field]
              .toLocaleDateString("ko-KR")
              .replaceAll(". ", "-")
              .replaceAll(".", "");
          } else {
            post_data[field] = data[field];
          }
        }
      }
      return post_data;
    },
    firstStep(validated, model) {
      if (validated) {
        let data = this.getfirstStepData();
        this.$store
          .createCity(data)
          .then(response => {
            this.wizardComplete();
          })
          .catch(error => {
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top",
              timeout: 5000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "City created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        this.$router.push({ name: "City List" });
      });
    }
  }
};
</script>
